import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { IBoardList } from '../../../../../app/resource/boards/boardList/boardList.types';
import { Board } from './Board';
import { Boards } from './Boards';
import { IBoardsWidgetProps } from './types';

export const BoardsWidget: FunctionComponent<IBoardsWidgetProps> = ({ meetingBoard, isAdmin, meetingId }) => {
  const [boardIds, setBoardIds] = useState(meetingBoard.boardIds);
  const [archivedBoardIds, setArchivedBoardIds] = useState(meetingBoard.archivedBoardIds);
  const [showAllBoards, setShowAllBoards] = useState(false);
  const [currentBoardId, setCurrentBoardId] = useState(meetingBoard.boardIds[0]);
  useEffect(() => {
    setBoardIds(meetingBoard.boardIds);
    setArchivedBoardIds(meetingBoard.archivedBoardIds);
    setCurrentBoardId(boardIds[0]);
  }, [boardIds, meetingBoard.boardIds, meetingBoard.archivedBoardIds, meetingId]);

  const handleCurrentBoardId = useCallback((boardId: string) => setCurrentBoardId(boardId), []);
  const boardListIds = !!currentBoardId
    ? meetingBoard.boardItems[Number(currentBoardId)]
      ? ((meetingBoard.boardItems[Number(currentBoardId)].boardListIds as unknown) as IBoardList['id'][])
      : []
    : [];

  return (
    <div className="row mb-25 mt-3">
      <div className="col-12">
        <div className="panel vto-text">
          <div className="panel-header justify-between small-header no-border pb-0 mb-2">
            <h2 className="bold mr-3">Boards</h2>
            <div className="flex aic mr-2">
              <p className="switch-inline-text mr-1">Active</p>
              <label className="switch big-switch mr-1 mb-0" htmlFor="showAllBoards">
                <input
                  type="checkbox"
                  className="switch-input change-theme"
                  id="showAllBoards"
                  name="showAllBoards"
                  checked={!showAllBoards}
                  onChange={() => setShowAllBoards(!showAllBoards)}
                />
                <span className="switch-label"></span>
                <span className="switch-handle"></span>
              </label>
              <p className="switch-inline-text mr-1">All</p>
            </div>
          </div>
          <Boards
            boardIds={boardIds}
            archivedBoardIds={archivedBoardIds}
            isAdmin={isAdmin}
            meetingId={meetingId}
            currentBoardId={handleCurrentBoardId}
            showAllBoards={showAllBoards}
          />
          {!!currentBoardId && (
            <Board boardId={currentBoardId} boardListIds={boardListIds} meetingId={meetingId} isAdmin={isAdmin} />
          )}
        </div>
      </div>
    </div>
  );
};
